import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { notification } from 'antd';
import { compose } from 'redux';
import { pending } from 'redux-saga-thunk';
import { formValueSelector, reduxForm, reset } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { modalHide } from '../store/modal/actions';
import { isOpen } from '../store/modal/selectors';
import { createValidator, maxSize, minSize, required } from '../services/validation';
import ProductFormModal from '../components/organisms/ProductFormModal';
import { emptyEditRecord } from '../store/updateCampaign/actions';
import {
  resourceCreateRequest,
  resourceDetailReadRequest,
  resourceUpdateRequest,
} from '../store/resource/actions';
import { fromEntities } from '../store/selectors';

class ProductFormModalContainer extends Component {
  componentDidUpdate = prevProps => {
    if (
      this.props.visible &&
      get(this.props, 'activeInhand.product_id', false) !== false &&
      this.props.activeInhand.product_id !== prevProps.activeInhand.product_id
    ) {
      this.props.getProduct(this.props.activeInhand.product_id);
    }
  };

  render() {
    return <ProductFormModal {...this.props} />;
  }
}

const mapStateToProps = ({ modal, updateCampaign, ...state }) => {
  const activeProduct = fromEntities.getDetail(
    state,
    'advertiserAdProduct',
    updateCampaign.product_id
  );

  return {
    activeInhand: updateCampaign,
    currentCodes: formValueSelector('ProductForm')(state, 'upc_codes'),
    loading: pending(state, 'advertiserAdProduct'),
    visible: isOpen(modal, 'create-inhand-product'),
    isEdit: !isEmpty(updateCampaign),
    initialValues: {
      ...activeProduct,
      prefix_len:
        !get(activeProduct, 'prefix_len') && get(activeProduct, 'prefix_len') !== 0
          ? 9
          : activeProduct.prefix_len,
      min_age: get(activeProduct, 'min_age', 0) === 21,
    },
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { lineItemId },
    },
  }
) => ({
  getProduct: id =>
    dispatch(
      resourceDetailReadRequest('advertiser-ad/:lineItemId/product/:id', {
        lineItemId,
        id,
      })
    ),
  addProduct: data =>
    dispatch(resourceCreateRequest('advertiser-ad/:id/inhand', { id: lineItemId }, data)),
  createProduct: data =>
    dispatch(resourceCreateRequest('advertiser-ad/:lineItemId/product', { lineItemId }, data)),
  updateProduct: data =>
    dispatch(
      resourceUpdateRequest(
        'advertiser-ad/:lineItemId/product/:id',
        { lineItemId, id: data.product_id },
        data
      )
    ),
  onCancel: () => {
    dispatch(modalHide('create-inhand-product'));

    // Timeout because hiding is a slow fade.
    // We don't want to flash the form resetting
    setTimeout(() => dispatch(emptyEditRecord()), 100);
  },
});

const onSubmit = (values, dispatch, props) => {
  if (values.min_age) {
    values.min_age = 21;
  } else {
    values.min_age = 0;
  }

  if (values.cat_id) {
    values.cat_id = parseInt(values.cat_id, 10);
  }
  if (values.prefix_len || values.prefix_len === 0 || values.prefix_len === '0') {
    values.prefix_len = parseInt(values.prefix_len, 10);
  }
  if (values.alcohol_type_id) {
    values.alcohol_type_id = parseInt(values.alcohol_type_id, 10);
  }

  if (!props.isEdit) {
    return props
      .createProduct(values)
      .then(id => props.addProduct({ product_id: id }))
      .then(() => {
        dispatch(reset('ProductForm'));
        props.onCancel();
      })
      .catch(e => {
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not create product.',
          duration: 0,
        });
      });
  }

  return props
    .updateProduct(values)
    .then(() => {
      props.onCancel();
      notification.success({ message: 'Success', description: 'Product updated.', duration: 4 });
    })
    .catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not create product.',
        duration: 0,
      });
    });
};
const validate = createValidator({
  name: [required],
  descr: [required],
  prefix_len: [minSize(0), maxSize(12)],
  cat_id: [required],
  url_image: [required],
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: 'ProductForm',
    onSubmit,
    enableReinitialize: true,
    validate,
  })
)(ProductFormModalContainer);
